<script setup>
import { __ } from '@/utils';
import { ref, watch, onMounted, onBeforeUnmount } from 'vue';
import { useField } from 'vee-validate';
import { formFragmentValues, setFormFragmentValues } from "@/utils";

const operators = [
	{ id: 'CS018', name: __('Expon') },
	{ id: 'CS016', name: __('Golan') },
	{ id: 'CS017', name: __('Hot Mobile') },
	{ id: 'CS012', name: __('012/Gold lines') },
	{ id: 'CS013', name: __('Barak/Netvizin') },
	{ id: 'CS014', name: __('Bezek international') },
	{ id: 'CS015', name: __('Hello') },
	{ id: 'CS019', name: __('Telezer') },
];

function getNameById(id) {
    const operator = operators.find(op => op.id === id);
    return operator ? operator.name : null;
}

const localValues = formFragmentValues();
const selectedOperator = ref(localValues.selectedOperator !== undefined ? getNameById(localValues.selectedOperator) : operators[0].name);
const selectedOperatorID = ref(localValues.selectedOperator !== undefined ? localValues.selectedOperator : operators[0].id);
const showDropDown = ref(false);
const { handleChange } = useField('internationalOperator');

const toggleDropDown = () => {
	showDropDown.value = !showDropDown.value;
}

const selectOperator = (operator) => {
	selectedOperator.value = operator.name;
	selectedOperatorID.value = operator.id
	toggleDropDown();
}

handleChange(selectedOperatorID.value);

watch(selectedOperatorID, () => {
	setFormFragmentValues({
		selectedOperator: selectedOperatorID.value
	})
	handleChange(selectedOperatorID.value);
});

const handleClickOutside = (event) => {
  const dropdownElement = document.querySelector('.dropdown-operators');
  if (dropdownElement && !dropdownElement.contains(event.target)) {
    showDropDown.value = false;
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
});
</script>
<template>
	<div class="choice">
		<span clas="choice__label">
			{{ __('An international operator') }}
		</span>

		<div class="dropdown dropdown-operators" :class="{ 'is-active': showDropDown }">
			<div class="dropdown__head" @click="toggleDropDown">
				<span>
					{{ selectedOperator }}
				</span>
			</div><!-- /.dropdown__head -->

			<div class="dropdown__list" v-if="showDropDown">
				<ul>
					<li v-for="operator in operators" :key="operator.id">
						<a href="#" @click.prevent="selectOperator(operator)">
							<span>
								{{ operator.name }}
							</span>
						</a>
					</li>
				</ul>
			</div><!-- /.dropdown__list -->
		</div><!-- /.dropdown -->
	</div><!-- /.choice -->
</template>
